module.exports = Em.Route.extend({
    model: function(params) {
        this.replaceWith('organization-invitation', params.token)
    }
})
